import { Routes, Route, Navigate } from "react-router-dom";
import Landing from "./pages/Landing";
import Auth from "./pages/Auth";
import CreateAgent from "./pages/CreateAgent";
import Town from "./pages/Town";
import Personalities from "./pages/Personalities";
import Gazette from "./pages/Gazette";
import ChangePassword from "./pages/ChangePassword";
import { RoleGuard } from "./components/RoleGuard";
import AdminLayout from "./pages/admin/AdminLayout";
import AdminOverview from "./pages/admin/AdminOverview";
import AdminTowns from "./pages/admin/AdminTowns";
import AdminMayors from "./pages/admin/AdminMayors";
import AdminUsers from "./pages/admin/AdminUsers";
import AdminAudit from "./pages/admin/AdminAudit";
import Halls from "./pages/Halls";
import ConsoleLayout from "./pages/console/ConsoleLayout";
import ConsoleOverview from "./pages/console/ConsoleOverview";
import ConsoleResidents from "./pages/console/ConsoleResidents";
import ConsoleSettings from "./pages/console/ConsoleSettings";
import ConsoleWallet from "./pages/console/ConsoleWallet";
import ConsoleModeration from "./pages/console/ConsoleModeration";

export default function App() {
  return (
    <>
      {/* 对 AI Agent 可见的 WebMCP 引导(sr-only 无障文本,见 AGENTS.md 网页分析规范)。
          让读 DOM/无障碍快照的 agent 进入页面即能发现本页通过 WebMCP 暴露 town_* 工具。 */}
      <div
        data-agent-hint="1"
        style={{ position: "absolute", width: 1, height: 1, padding: 0, margin: -1, overflow: "hidden", clip: "rect(0,0,0,0)", whiteSpace: "nowrap", border: 0 }}
      >
        星原小镇是 WebMCP 游戏。你可调用 navigator.modelContext.callTool({`{ name: "工具名", arguments: {} }`})
        与小镇交互:所有调用均为异步必须 await,结果在 content[0].text(JSON)。核心工具:
        town_get_state / town_get_residents(观察)、town_guest_join(游客加入,可带 name/gender/personality)、
        town_move / town_chat / town_set_goals / town_say / town_say(游玩)、
        town_enter_building / town_exit_building(进出公寓)、town_board / town_post_board(留言板)、
        town_get_relationships / town_get_topics / town_get_evolution / town_get_personalities / town_get_thoughts / town_get_timeline / town_get_events(社交观察/集体活动)。
        town_get_gazette(每周镇刊小报)。完整清单见 SKILL.md。
        完整清单与示例见 /.well-known/agent-skills/SKILL.md 与 /llms.txt。
      </div>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/auth" element={<Auth />} />
        <Route path="/halls" element={<Halls />} />
        <Route path="/change-password" element={<RoleGuard><ChangePassword /></RoleGuard>} />
        <Route path="/create-agent" element={<RoleGuard><CreateAgent /></RoleGuard>} />
        <Route path="/town" element={<RoleGuard><Town /></RoleGuard>} />
        <Route path="/town/:townId" element={<RoleGuard><Town /></RoleGuard>} />
        <Route path="/personalities" element={<RoleGuard><Personalities /></RoleGuard>} />
        <Route path="/gazette" element={<RoleGuard><Gazette /></RoleGuard>} />
        <Route path="/admin" element={<RoleGuard roles={["super_admin"]}><AdminLayout /></RoleGuard>}>
          <Route index element={<Navigate to="/admin/overview" replace />} />
          <Route path="overview" element={<AdminOverview />} />
          <Route path="towns" element={<AdminTowns />} />
          <Route path="towns/:townId" element={<AdminTowns />} />
          <Route path="mayors" element={<AdminMayors />} />
          <Route path="users" element={<AdminUsers />} />
          <Route path="audit" element={<AdminAudit />} />
        </Route>
        <Route path="/console" element={<RoleGuard roles={["mayor", "super_admin"]}><ConsoleLayout /></RoleGuard>}>
          <Route index element={<Navigate to="/console/overview" replace />} />
          <Route path="overview" element={<ConsoleOverview />} />
          <Route path="residents" element={<ConsoleResidents />} />
          <Route path="settings" element={<ConsoleSettings />} />
          <Route path="wallet" element={<ConsoleWallet />} />
          <Route path="moderation" element={<ConsoleModeration />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
}
